import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { styles } from '../../styles/styles';
import useWindowResize from '../../hooks/useWindowResize';
import { useThoughtCompose } from '../../hooks/useThoughtCompose';

import MobileLayout from './layouts/MobileLayout';
import DesktopLayout from './layouts/DesktopLayout';
import ThoughtEditor from './ThoughtEditor';
import ActionButtons from './ActionButtons';
import NavigationButton from './NavigationButton';

const ComposePage = ({ onSave, isEditing = false, thoughts = [] }) => {
    const navigate = useNavigate();
    const { id } = useParams();
    const existingThought = isEditing && id ? thoughts.find(t => t.id === id) : null;
    const isMobile = useWindowResize();
    
    const {
        thought,
        setThought,
        isSaving,
        handleSave
    } = useThoughtCompose({
        onSave,
        isEditing,
        existingThought,
        thoughtId: id
    });

    const handleClose = () => isEditing ? navigate(`/thought/${id}`) : navigate('/');
    
    const Layout = isMobile ? MobileLayout : DesktopLayout;
    const layoutProps = {
        styles,
        onClose: handleClose
    };

    return (
        <Layout {...layoutProps}>
            <NavigationButton 
                onClick={handleClose}
                isMobile={isMobile}
                styles={styles}
            />
            
            <ThoughtEditor 
                value={thought}
                onChange={setThought}
                styles={styles}
                isMobile={isMobile}
            />
            
            <ActionButtons 
                isEditing={isEditing}
                isSaving={isSaving}
                onSave={handleSave}
                thought={thought}
                styles={styles}
                isMobile={isMobile}
            />
        </Layout>
    );
};

export default ComposePage; 